import React from 'react';
import { ChevronRight, Layers } from 'lucide-react';
import { formatRelativeTime } from './NotificationDetailModal';

export default function NotificationStackRow({
  stack,
  onSelect,
  dense = false,
  className = '',
}) {
  if (!stack?.latest) return null;
  const stacked = stack.count > 1;
  const pad = dense ? 'px-3.5 py-2.5' : 'px-4 py-3.5';

  return (
    <button
      type="button"
      onClick={() => onSelect?.(stack)}
      className={`group relative w-full text-left ${pad} flex items-start gap-2.5 hover:bg-teal-50/60 transition-colors border-b border-gray-50 last:border-b-0 ${
        stack.read ? 'bg-white' : 'bg-teal-50/35'
      } ${className}`.trim()}
    >
      {stacked ? (
        <span className="relative mt-0.5 h-8 w-8 flex-shrink-0" aria-hidden="true">
          <span className="absolute left-1 top-1 h-7 w-7 rounded-xl bg-gray-200/90" />
          <span className="absolute left-0.5 top-0.5 h-7 w-7 rounded-xl bg-gray-100 border border-gray-200/80" />
          <span
            className={`absolute inset-0 flex items-center justify-center rounded-xl border ${
              stack.read
                ? 'bg-white border-gray-200 text-gray-500'
                : 'bg-teal-600 border-teal-600 text-white'
            }`}
          >
            <Layers className="w-3.5 h-3.5" strokeWidth={2} />
          </span>
        </span>
      ) : (
        <span
          className={`mt-1.5 h-1.5 w-1.5 rounded-full flex-shrink-0 ${
            stack.read ? 'bg-gray-300' : 'bg-teal-500'
          }`}
          aria-hidden="true"
        />
      )}

      <div className="flex-1 min-w-0">
        <div className="flex items-start justify-between gap-2">
          <p className={`${dense ? 'text-[13px]' : 'text-sm'} font-medium text-gray-900 truncate`}>
            {stack.title}
          </p>
          <span className="text-[10px] text-gray-400 flex-shrink-0 tabular-nums">
            {formatRelativeTime(stack.receivedAt)}
          </span>
        </div>
        <div className="mt-0.5 flex items-center gap-1.5 min-w-0">
          <p className="text-[10px] font-semibold text-teal-700 truncate">
            {stack.typeLabel}
          </p>
          {stacked ? (
            <span className="inline-flex items-center rounded-full bg-teal-50 text-teal-800 border border-teal-100 px-1.5 py-px text-[10px] font-bold tabular-nums flex-shrink-0">
              {stack.count}
            </span>
          ) : null}
          {stack.unreadCount > 0 ? (
            <span className="inline-flex items-center rounded-full bg-red-500 text-white px-1.5 py-px text-[10px] font-bold tabular-nums flex-shrink-0">
              {stack.unreadCount > 99 ? '99+' : stack.unreadCount}
            </span>
          ) : null}
        </div>
        {stack.subtitle ? (
          <p className={`${dense ? 'text-[11px]' : 'text-xs'} text-gray-500 mt-0.5 line-clamp-2`}>
            {stack.subtitle}
          </p>
        ) : null}
      </div>

      <ChevronRight
        className="w-4 h-4 text-gray-300 group-hover:text-teal-600 flex-shrink-0 mt-1 transition-colors"
        strokeWidth={2}
        aria-hidden="true"
      />
    </button>
  );
}
